import { Button } from "@/components/ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { Layers, Check } from "lucide-react";

export function MapBasemapSelector({ basemaps, basemap, onBasemapChange }) {
  return (
    <div className="absolute top-3 right-3 z-10 basemap-selector-container">
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button size="icon" variant="secondary" className="w-10 h-10 bg-white/95 backdrop-blur-sm border border-gray-200 shadow-lg rounded-lg hover:bg-gray-50" data-testid="basemap-selector">
            <Layers className="w-5 h-5 text-gray-600" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="w-40">
          <DropdownMenuLabel className="text-xs text-gray-500">Map Style</DropdownMenuLabel>
          {Object.entries(basemaps).map(([key, value]) => {
            const Icon = value.icon;
            return (
              <DropdownMenuItem key={key} onClick={() => onBasemapChange(key)} className={`cursor-pointer ${basemap === key ? 'bg-accent/10 text-accent' : ''}`}>
                <Icon className="w-4 h-4 mr-2" />{value.name}{basemap === key && <Check className="w-4 h-4 ml-auto" />}
              </DropdownMenuItem>
            );
          })}
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
}
